<template>
  <div class="action-list mb-3">
    <div class="dropdown-float width-200-px">
      <span>Periode Tahun</span>
      <b-form-select :value="year" @input="$emit('update:year', $event)">
        <b-form-select-option value="2022">2022</b-form-select-option>
        <b-form-select-option value="2023">2023</b-form-select-option>
        <b-form-select-option value="2024">2024</b-form-select-option>
        <b-form-select-option value="2025">2025</b-form-select-option>
        <b-form-select-option value="2026">2026</b-form-select-option>
      </b-form-select>
    </div>

    <div class="input-group-custom search-input">
      <!-- Ditambahkan style="cursor: text;" untuk memaksa kursor kembali normal -->
      <input
        v-model="localSearch"
        type="text"
        class="form-control"
        placeholder="Cari kode atau nama proyek..."
        style="cursor: text;"
      />
      <!-- Ditambahkan style="cursor: pointer;" agar ikon kaca pembesar yang bisa diklik tetap memiliki efek tangan -->
      <feather
        type="search"
        size="18"
        class="search-icon"
        style="cursor: pointer;"
        @click="triggerSearchImmediately"
      ></feather>
    </div>

    <b-dropdown
      variant="primary"
      right
      text="Download"
      class="dropdown-download"
      toggle-class="d-flex align-items-center gap-1"
    >
      <template v-slot:button-content>
        <feather type="download" size="16"></feather> Download
      </template>

      <b-dropdown-item @click="$emit('export', 'excel')">
        <div class="d-flex align-items-center gap-2 text-success">
          <feather type="file-text" size="16"></feather> Export ke Excel
        </div>
      </b-dropdown-item>

      <b-dropdown-item @click="$emit('export', 'pdf')">
        <div class="d-flex align-items-center gap-2 text-danger">
          <feather type="file" size="16"></feather> Export ke PDF
        </div>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: 'ProjectFilter',
  props: {
    year: { type: String, required: true },
    qCari: { type: String, required: true },
  },
  data() {
    return {
      // Menyimpan data ketikan user sementara di local state
      localSearch: this.qCari,
      debounceTimeout: null,
    }
  },
  watch: {
    // Menjaga sinkronisasi jika qCari diubah dari luar (parent component)
    qCari(newVal) {
      if (newVal !== this.localSearch) {
        this.localSearch = newVal
      }
    },
    // Mengawasi ketikan user untuk memicu debounce
    localSearch(newVal) {
      // 1. Update ke parent via .sync (.sync mendengarkan update:qCari)
      this.$emit('update:qCari', newVal)

      // 2. Clear timeout sebelumnya jika user masih mengetik
      clearTimeout(this.debounceTimeout)

      // 3. Set timeout baru (500ms setelah user berhenti mengetik)
      this.debounceTimeout = setTimeout(() => {
        this.$emit('search')
      }, 500) // Kamu bisa ubah 500ms sesuai kebutuhan kenyamanan user
    },
  },
  methods: {
    // Jika ikon kaca pembesar diklik, langsung cari tanpa nunggu debounce habis
    triggerSearchImmediately() {
      clearTimeout(this.debounceTimeout)
      this.$emit('search')
    },
  },
}
</script>
